import { useEffect } from 'react';

const ICON_URLS: string[] = [
  // Common navbar and menu icons (some also preloaded via <link>)
  '/images/logo.svg',
  '/icons/drawer.svg',
  '/images/discord.svg',
  '/images/telegram.svg',
  '/images/x.svg',
  '/images/lightning.svg',
  '/images/bridge.svg',
  // Icons used in share overlays and empty states
  '/images/x-black.svg',
  '/images/empty.svg',
  '/images/share-up.svg',
  '/images/share-down.svg',
  // Misc frequently used icons in views
  '/icons/ratherThan.svg',
  '/icons/general-point.svg',
  '/icons/high-leverage.svg',
  '/icons/lvusd-full.svg',
  '/icons/lvmon-full.svg',
]

export function IconPreloader() {
  useEffect(() => {
    ICON_URLS.forEach((url) => {
      try {
        // Use fetch for better caching control with SVGs
        // Fallback to Image() if fetch is unavailable
        if (typeof fetch === 'function') {
          fetch(url, {
            // Cache aggressively; these are static assets with content hashing not used,
            // but they live under /public and can be updated with deploys.
            cache: 'force-cache',
          }).catch(() => {
            const img = new Image();
            img.decoding = 'async';
            img.src = url;
          });
        } else {
          const img = new Image();
          img.decoding = 'async';
          img.src = url;
        }
      } catch {
        const img = new Image();
        img.decoding = 'async';
        img.src = url;
      }
    });
    // no abort on unmount: these are tiny cached static SVGs — aborting
    // only produced dev-overlay AbortError noise (which also scroll-locked
    // the page while the overlay was open)
  }, []);

  return null;
}


